import PubSiteAdminService from '@/services/admin/pubsiteadmin.service'
import router from '@/router'

const state =  {
}

const getters = {
}

const actions = {
    async getPublicSiteStatus({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await PubSiteAdminService.getPublicSiteStatus(payload);

            return response
        } catch (e) {
            // console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }
    },
    async unlockPublicSite({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await PubSiteAdminService.unlockPublicSite(payload);

            return response
        } catch (e) {
            // console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }
    },

}

const mutations = {
}

export const adminPubSiteAdmin = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}